import z from "zod";

export const UIMessageMetadata = z.object({
  selectionId: z.string().optional(),
  titleNumber: z.string().optional(),
  addresses: z.array(z.string()).optional(),
  lpaName: z.string().optional(),
  lpaGssCode: z.string().optional(),
  region: z.string().optional(),
});

export type UIMessageMetadata = z.infer<typeof UIMessageMetadata>;
